import { Grid2D } from '../base/Grid2D';

export class SandGrid extends Grid2D {
  constructor(width: number, height: number, initialHeight: number = 0) {
    super(width, height, initialHeight);
  }

  /**
   * Clone this sand grid.
   */
  public clone(): SandGrid {
    const cloned = new SandGrid(this.width, this.height);
    cloned.data.set(this.data);
    return cloned;
  }

  /**
   * Get the maximum height in the grid (alias for backward compatibility).
   */
  public getMaxHeight(): number {
    return this.getMax();
  }
}
